import { CHECKOUT_PRODUCTS_SESSION_STORAGE_KEY } from './constants';

import {
  getSessionStorageItem,
  removeSessionStorageItem,
  setSessionStorageItem,
} from '@/modules/storage';

const listeners = new Set<() => void>();

export function subscribeCheckoutProducts(onStoreChange: () => void) {
  listeners.add(onStoreChange);

  return () => {
    listeners.delete(onStoreChange);
  };
}

function notifyCheckoutProductsChanged() {
  listeners.forEach((listener) => listener());
}

export function readStoredCheckoutProducts() {
  return getSessionStorageItem(CHECKOUT_PRODUCTS_SESSION_STORAGE_KEY);
}

export function setStoredCheckoutProducts(value: string) {
  setSessionStorageItem(CHECKOUT_PRODUCTS_SESSION_STORAGE_KEY, value);
  notifyCheckoutProductsChanged();
}

export function clearStoredCheckoutProducts() {
  removeSessionStorageItem(CHECKOUT_PRODUCTS_SESSION_STORAGE_KEY);
  notifyCheckoutProductsChanged();
}
